var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/instagramBlack.70c3b58a.png","uri@3x": __webpack_public_path__ + "static/media/instagramBlack.24ca6fd5.png","uri@2x": __webpack_public_path__ + "static/media/instagramBlack.0b50be6a.png",
    width: 24,
    height: 24
});